import { POSITION } from "@voltmoney/types";
import { ROUTE } from "../../../routes";
import { Platform, ToastAndroid } from 'react-native';
import { api, config } from "../../../configs/api";
import { APP_CONFIG, getAppHeader } from "../../../configs/config";
import SharedPropsService, { BUILD_TYPE, getBuildType } from "../../../SharedPropsService";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconTokens, SizeTypeTokens, WIDGET } from "@voltmoney/schema";
import { LENDER_ID, REPAYMENT_COLLECTION_TYPE } from "../../../configs/constants";
import sharedPropsService from "../../../SharedPropsService";
import { isIframe } from "../../payment/paymentStart/actions";
import { isFromAndroidWebview } from "../../../configs/utils";
import { getParameters } from "../../../configs/uri-config-utils";
export const repayment = async (action, _datastore, { navigate, setDatastore, asyncStorage }) => {
    await navigate(ROUTE.DASHBOARD);
};
export const goBack = async (action, _datastore, { navigateWithClear, navigate }) => {
    const isLoanRenewalPaymentActive = await sharedPropsService.getIsLoanRenewalRepaymentActive();
    if (isLoanRenewalPaymentActive) {
        await navigateWithClear(ROUTE.REPAYMENT);
    }
    else {
        await navigate(ROUTE.DASHBOARD);
    }
};
export const copyToClipboard = async (action, _datastore, { clipboard, network, setDatastore }) => {
    const userContextResponse = await SharedPropsService.getUser();
    const principalOutstadingamount = userContextResponse.linkedCredits[0].principalOutStandingAmount;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const hasNotWithdrawn = principalOutstadingamount === null || principalOutstadingamount === 0;
    if (hasNotWithdrawn && Platform.OS === 'android') {
        ToastAndroid.show("Please withdraw to start making payment", ToastAndroid.SHORT);
    }
    else {
        Platform.OS === 'ios' ? alert("Copied to clipboard!") : Platform.OS === 'android' && ToastAndroid.show("Copied to clipboard!", ToastAndroid.SHORT);
        clipboard.set(action.payload.value);
    }
    const widgetId = action?.payload?.widgetId;
    if (widgetId) {
        await setDatastore(ROUTE.REPAYMENT, widgetId, {
            trailLabel: {
                label: 'Copied',
                fontSize: FontSizeTokens.XS,
                color: ColorTokens.Primary_100,
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 18,
                fontWeight: '500',
            },
        });
        setTimeout(async () => {
            await setDatastore(ROUTE.REPAYMENT, widgetId, {
                trailLabel: {
                    label: 'Copy',
                    fontSize: FontSizeTokens.XS,
                    color: ColorTokens.Primary_100,
                    fontFamily: FontFamilyTokens.Inter,
                    lineHeight: 18,
                    fontWeight: '500',
                },
            });
        }, 1500);
    }
};
export const goToPaymentPage = async (action, _datastore, { instrumentTrack, navigateWithClear }) => {
    instrumentTrack("MAKE_ONLINE_PAYMENT_BUTTON_CLICKED");
    await navigateWithClear(ROUTE.PAYMENT_START);
};
export const needHelp = async (action, _datastore, { instrumentTrack, navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const navToInfo = async (action, _datastore, { navigate }) => {
    console.warn("*** navToInfo action triggered ***");
    navigate(ROUTE.REPAYMENT_CHARGES_DETAILS_PAGE);
};
export const leadToPayment = async (action, _datastore, { network, appendWidgets, openNewTab, removeWidgets, showPopup, setDatastore, goBack, navigate, }) => {
    const amount = action?.payload?.amount;
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const userCreditId = userContextResponse.data.linkedCredits[0].creditId;
    let popupWindow;
    const test_numbers_bajaj_pg = await SharedPropsService.getFirebaseConfig()?.test_numbers_bajaj_pg;
    if (!test_numbers_bajaj_pg) {
        return false;
    }
    const test_numbers_bajaj_pg_object = JSON.parse(test_numbers_bajaj_pg);
    const user = await SharedPropsService.getUser();
    const bajajPgPhoneNumbers = test_numbers_bajaj_pg_object?.numbers;
    let showBajajPg = await SharedPropsService.getFirebaseConfig().show_bajaj_pg;
    let buildType = getBuildType();
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = getParameters(url);
    const platformCode = params?.platform || '';
    let enableBajajPG = false;
    if (platformCode === undefined || platformCode === null || platformCode === '') {
        enableBajajPG = true;
    }
    else
        enableBajajPG = false;
    // @ts-ignore
    let isPaymentModeBajaj = enableBajajPG && (showBajajPg === true || showBajajPg === "true" || bajajPgPhoneNumbers.includes(user.user.phoneNumber)) && (userContextResponse.data.linkedApplications[0].lenderAccountId !== "Tata");
    const lenderAccountId = userContextResponse.data.linkedApplications[0].lenderAccountId;
    let tataFlag = false;
    if (lenderAccountId.toLowerCase() === LENDER_ID.TATA.toLowerCase()) {
        const accountId = userContextResponse?.data.linkedApplications[0].accountId;
        const response = await network.get(`${api.isTataMergerEnabled}${accountId}`, { headers: await getAppHeader() });
        tataFlag = response?.data?.isEnabled;
    }
    await sharedPropsService.setIsLoanRenewalRepaymentActive(true);
    await setDatastore(ROUTE.REPAYMENT, "makeOnlinePayment", {
        loading: true
    });
    await network.post(`${api.collectionNew}`, {
        collectionAmount: `${amount}`,
        baseOriginUrl: `${config.APP_URL}`,
        paymentGatewayType: isPaymentModeBajaj ? "BAJAJ" : null,
        creditId: userCreditId,
        redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false,
        collectionType: `${REPAYMENT_COLLECTION_TYPE.LOAN_EXPIRED_DUE_REPAYMENT}`
    }, { headers: await getAppHeader() })
        .then(async (res) => {
        if (res.status === 200) {
            const isFromTata = userContextResponse.data.linkedApplications[0].lenderAccountId = "Tata";
            if (Platform.OS !== 'web') {
                console.warn("LINK RECEIVED IS", res.data.paymentLink);
                await removeWidgets(ROUTE.REPAYMENT, [
                    {
                        id: "noAmountToPayCard",
                        type: WIDGET.STACK,
                    },
                    {
                        id: "amountItem",
                        type: WIDGET.AMOUNTCARD,
                    },
                    {
                        id: "space0",
                        type: WIDGET.SPACE,
                    },
                    {
                        id: "makeOnlinePayment",
                        type: WIDGET.BUTTON,
                    },
                    {
                        id: "spaceXXXL",
                        type: WIDGET.SPACE,
                    },
                    {
                        id: "headStack",
                        type: WIDGET.TEXT,
                    },
                    {
                        id: "headSpace",
                        type: WIDGET.SPACE,
                    },
                    {
                        id: "messageStack",
                        type: WIDGET.TEXT,
                    },
                    {
                        id: "messageSpace",
                        type: WIDGET.SPACE,
                    },
                    {
                        id: "bankStack",
                        type: WIDGET.STACK,
                    },
                    {
                        id: "dividerTopSpace",
                        type: WIDGET.SPACE,
                    },
                    {
                        id: "divider",
                        type: WIDGET.DIVIDER,
                    },
                    {
                        id: "listItem1",
                        type: WIDGET.LIST_ITEM,
                    },
                    {
                        id: "listItem2",
                        type: WIDGET.LIST_ITEM,
                    },
                    {
                        id: "listItem3",
                        type: WIDGET.LIST_ITEM,
                    },
                    {
                        id: "listItem4",
                        type: WIDGET.LIST_ITEM,
                    },
                    {
                        id: "listSpace",
                        type: WIDGET.SPACE,
                    },
                ]);
                await appendWidgets(ROUTE.REPAYMENT, {
                    repayLoanWebView: {
                        iframe: false,
                        uri: res.data.paymentLink
                    },
                    keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                    keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                    keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                    spaceXXL: { size: SizeTypeTokens.XXL }
                }, [
                    // {id: "spaceXXL", type: WIDGET.SPACE},
                    { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                    // {id: "keyboardSpace", type: WIDGET.SPACE},
                    // {id: "keyboardSpace2", type: WIDGET.SPACE},
                    // {id: "keyboardSpace3", type: WIDGET.SPACE},
                ], "repaymentReference_DO_NOT_REMOVE");
                const runPollar = async () => {
                    network.get(`${api.userPaymentData}${res.data.collectionId}`, {
                        headers: await getAppHeader(),
                        routeName: "REPAYMENT"
                    }).then(async (response) => {
                        if (response.data.collectionStatus !== 'REQUESTED') {
                            clearInterval(timer);
                            await removeWidgets(ROUTE.REPAYMENT, [
                                { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                { id: "keyboardSpace", type: WIDGET.SPACE },
                                { id: "keyboardSpace2", type: WIDGET.SPACE },
                                { id: "keyboardSpace3", type: WIDGET.SPACE },
                                { id: "spaceXXL", type: WIDGET.SPACE }
                            ]);
                            await navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                        }
                    });
                };
                const timer = setInterval(async () => {
                    await runPollar();
                }, APP_CONFIG.POLLING_INTERVAL);
            }
            else {
                if ((isIframe() || isFromAndroidWebview()) && !isPaymentModeBajaj) {
                    showPopup({
                        isAutoTriggerCta: true,
                        type: 'DEFAULT',
                        iconName: IconTokens.Redirecting,
                        title: 'Waiting for response',
                        subTitle: 'Please wait while we process your request',
                        primary: false,
                    });
                    const url = res.data.paymentLink;
                    // Popup window size
                    const width = isFromTata ? 1002 : 504;
                    const height = 704;
                    // Calculate the position to center the popup on the screen
                    const left = (window.innerWidth - width) / 2;
                    const top = (window.innerHeight - height) / 2;
                    if (isFromAndroidWebview()) {
                        popupWindow = window.open(url, "_blank");
                    }
                    else {
                        popupWindow = window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
                    }
                }
                else {
                    if (isFromTata) {
                        if (lenderAccountId.toLowerCase() === "bajaj" && isPaymentModeBajaj) {
                            if (isIframe()) {
                                const form = document.createElement('form');
                                form.method = 'POST';
                                form.action = buildType === BUILD_TYPE.BORROWER_PRODUCTION ? ' https://payment.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment'
                                    : 'https://uatpayments.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment';
                                form.target = 'paymentPopup'; // Add target for the popup window
                                // Create an input element
                                const input = document.createElement('input');
                                input.type = 'hidden';
                                input.name = 'msg';
                                input.value = res.data.paymentLink;
                                popupWindow = window.open('', 'paymentPopup', 'width=600,height=600');
                                // Append input to form
                                form.appendChild(input);
                                document.body.appendChild(form);
                                form.submit();
                            }
                            else {
                                const form = document.createElement('form');
                                form.method = 'POST';
                                form.action = buildType === BUILD_TYPE.BORROWER_PRODUCTION ? ' https://payment.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment'
                                    : 'https://uatpayments.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment';
                                form.target = 'paymentPopup'; // Add target for the popup window
                                // form.target = 'paymentPopup'; // Add target for the popup window
                                // Create an input element
                                const input = document.createElement('input');
                                input.type = 'hidden';
                                input.name = 'msg';
                                input.value = res.data.paymentLink;
                                //  popupWindow = window.open('', 'paymentPopup', 'width=600,height=600');
                                // Append input to form
                                form.appendChild(input);
                                document.body.appendChild(form);
                                form.submit();
                            }
                            // Open a new popup window with the specified size
                        }
                        else {
                            const tataPaymentLink = res.data.paymentLink;
                            window.open(tataPaymentLink, "_self");
                            setDatastore(ROUTE.OUTSTANDING_DUES, "makeOnlinePayment", {
                                loading: false
                            });
                        }
                    }
                    else {
                        appendWidgets(ROUTE.PAYMENT_START, {
                            repayLoanWebView: {
                                iframe: Platform.OS === 'web',
                                uri: res.data.paymentLink
                            },
                            keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                            keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                            keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                        }, [
                            { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                            { id: "keyboardSpace", type: WIDGET.SPACE },
                            { id: "keyboardSpace2", type: WIDGET.SPACE },
                            { id: "keyboardSpace3", type: WIDGET.SPACE },
                        ], "header");
                        removeWidgets(ROUTE.PAYMENT_START, [
                            {
                                id: "totalAmountShowStack",
                                type: WIDGET.CARD,
                                padding: {
                                    horizontal: 0,
                                    all: 0,
                                },
                                position: POSITION.ABSOLUTE_TOP,
                            },
                            {
                                id: "spaceLG",
                                type: WIDGET.SPACE
                            },
                            {
                                id: "titleStack",
                                type: WIDGET.STACK,
                            },
                            {
                                id: "spaceXXXL",
                                type: WIDGET.SPACE
                            },
                            {
                                id: "selectFullAmountStack",
                                type: WIDGET.STACK
                            },
                            {
                                id: "spaceXXXL",
                                type: WIDGET.SPACE
                            },
                            {
                                id: "divider",
                                type: WIDGET.DIVIDER
                            },
                            {
                                id: "partialAmountFullStack",
                                type: WIDGET.STACK
                            },
                            {
                                id: "proceedButtonStack",
                                type: WIDGET.STACK,
                                position: POSITION.ABSOLUTE_BOTTOM
                            },
                            {
                                id: "spaceLG",
                                type: WIDGET.SPACE
                            },
                            { id: "enterAmountFullStack", type: WIDGET.STACK },
                            { id: "amountMessage", type: WIDGET.TEXT }
                        ]);
                        setDatastore(action.routeId, "customHeader", {
                            title: (isFromTata)
                                ? (tataFlag
                                    ? "Paying to Tata Capital Limited"
                                    : "Paying to Tata Capital Financial Services Ltd.")
                                : "Paying to Bajaj Finance"
                        });
                    }
                }
                if (isIframe()) {
                    const runPollar = async () => {
                        network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }, async () => {
                            return;
                        }, {
                            disableDefault: true
                        }).then((response) => {
                            if (popupWindow.closed) {
                                goBack();
                                clearInterval(timer);
                            }
                            else {
                                if (response.data.collectionStatus === 'COLLECTION_COMPLETE' || response.data.collectionStatus === 'CANCELLED' || response.data.collectionStatus === 'FAILED') {
                                    removeWidgets(ROUTE.PAYMENT_START, [
                                        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                        { id: "keyboardSpace", type: WIDGET.SPACE },
                                        { id: "keyboardSpace2", type: WIDGET.SPACE },
                                        { id: "keyboardSpace3", type: WIDGET.SPACE },
                                    ]);
                                    clearInterval(timer);
                                    if (popupWindow) {
                                        popupWindow.close(); // Close the popup window if it exists
                                    }
                                    navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                }
                            }
                        });
                    };
                    const timer = setInterval(() => {
                        runPollar();
                    }, APP_CONFIG.POLLING_INTERVAL);
                }
            }
        }
        else {
            setDatastore(ROUTE.REPAYMENT, "makeOnlinePayment", {
                loading: false
            });
        }
    });
};
